import {useSelector} from "react-redux";
import {createModal} from "../../utils/modal";
import React from "react";
import ReactCountryFlag from "react-country-flag";

const HeaderButton = () => {
    const {locale} = useSelector(state => state.app)

    return (
        <div>
            <div onClick={() => createModal('theme_3_language')} className={'w-[35px] h-[35px] rounded-[35px] ml-2 border-[7px] border-white image-bg-thirdy flex justify-center items-center shadow-md'}>
                <ReactCountryFlag
                    countryCode={ locale === 'en' ? 'US' : locale === 'ar' ? 'SA' : locale.toUpperCase()}
                    style={{
                        fontSize: '1.7em',
                    }}
                />
            </div>
        </div>
    )
}

export default HeaderButton;
